<mat-dialog-content>
  <div class="use-line-break" *ngIf="data">
    {{data.text}}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <pezi-button text="Abbrechen" [isPlain]="true" icon="close" mat-dialog-close></pezi-button>
  <pezi-button text="Öffnen" mat-dialog-close (click)="navigateHome()" *ngIf="data && data.showHomeButton" [isAccent]="true"></pezi-button>
  <pezi-button text="ok" (clickEvent)="dialogRef.close('accept')"></pezi-button>
</mat-dialog-actions>



